export default function ({ store, redirect, query }) {
  const isSubscriber = store.getters['user/isSubscriber']
  const isUser = store.getters['user/isLoggedIn']

  if (isSubscriber) {
    return redirect('/my_account', query)
  } else if (isUser) {
    const { leadType = '' } = store.state.user?.details
    const { didFreeTrial } = store.state.checkout

    if (leadType === 'trialLead' && !didFreeTrial) {
      return redirect('/free_trial/recommendations', query)
    }

    return redirect('/recommendations', query)
  }
}
